import { render } from "./FirstTimersList.vue?vue&type=template&id=422c68b0&scoped=true"
import script from "./FirstTimersList.vue?vue&type=script&lang=js"
export * from "./FirstTimersList.vue?vue&type=script&lang=js"

import "./FirstTimersList.vue?vue&type=style&index=0&id=422c68b0&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-422c68b0"]])

export default __exports__